module.exports = __webpack_public_path__ + "img/diagital-process-content.d3f90076.png";